/* src/firebase.js
 * Firebase configuration and initialization for frontend
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Firebase configuration
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBKN7b9fJnEElPb9oHUqJSCbwXJ5WBJCOw",
  authDomain: "app.gocta.ai",
  projectId: "smartforms-ai",
  storageBucket: "smartforms-ai.firebasestorage.app",
  messagingSenderId: "882746856712",
  appId: "1:882746856712:web:dae47c746dd9d470adc8bd",
  measurementId: "G-87LZXL3MLE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Connect to emulators when REACT_APP_USE_EMULATORS=true
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
}

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
